import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const loginGoogle = createAsyncThunk(
  "loginGoogle/loginUsers",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("signup/google", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const loginGoogleSlice = createSlice({
  name: "loginGoogle",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginGoogle.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginGoogle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loginGoogle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginGoogleSlice.reducer;
